var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9756 0H8.42512C4.28858 0 2.75229 1.88727 2.66298 5.07757L2.65881 5.38046V7.86317H0V11.9985H2.65881V24H7.97887V11.9985H11.5294L12 7.86317H7.97887L7.98618 5.79323C7.98618 4.77148 8.08467 4.19905 9.50703 4.14163L9.75655 4.13683H11.9756V0Z",
    fill: "#13294B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.62bdee9607c71f49bc8fa924bbffa958.svg";
export { ForwardRef as ReactComponent };